export const tw = (strings: TemplateStringsArray): string => {
  return strings.join('')
}
